module.exports = __webpack_public_path__ + "img/空天海协同渔场预报服务平台.34688385.png";